
<template>
  <div class="userInformation">
    <div class="main" v-if="detailsType">
      <div class="top-search">
        <div class="item">
          <span>订单号：</span>
          <div>
            <el-input v-model="orderCodeVal" placeholder="单行输入"></el-input>
          </div>
        </div>
        <div class="item">
          <span>状态：</span>
          <div>
            <el-select v-model="statusVal" placeholder="请选择">
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="item">
          <span style="width: 50px;"></span>
          <el-button type="primary" @click="merchantsSearch" size="small">搜索</el-button>
          <el-button type="danger" @click="merchantsReset" size="small">重置</el-button>
        </div>
      </div>
      <div class="bottom-table">
        <el-table :data="userTableData" border :header-cell-style="{background:'rgb(250, 250, 250)'}" style="width: 100%">
          <el-table-column prop="order_id" label="订单号" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="name" label="个体工商名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="legalName" label="法人姓名" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="creditCode" label="统一社会信用代码" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="dstatusName" label="状态" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="address" label="操作" width="100">
            <template slot-scope="scope">
              <div style="cursor: pointer;">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    更多操作
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <el-button
                        @click="userDetails(scope.row)"
                        type="primary"
                        size="mini"
                        plain
                      >查看详情</el-button>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        :total="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>
    </div>
    <!-- 详情 -->
    <div class="main details" v-if="!detailsType">
      <div class="title">
        <div class="fanhui" @click="detailsType = true">
          <i class="el-icon-arrow-left"></i>返回
        </div>
        <div class="qianyue">客户签约</div>
      </div>
      <div class="content">
        <div class="name">执照信息</div>
        <div class="box1">
          <div class="list">
            <span>个体工商户名称：{{userListObj.name || '暂无'}}</span>
            <span>统一社会信用代码：{{userListObj.creditCode}}</span>
            <span>经营场所：{{userListObj.businessPlace}}</span>
          </div>
          <div class="list">
            <span>法人姓名：{{userListObj.legalName}}</span>
            <span>法人身份证号码：{{userListObj.idcard}}</span>
            <span>注册日期：2019-06-20</span>
          </div>
          <div class="list">经营范围：{{userListObj.businessScope}}</div>
          <div class="item">
            <div>执照照片：</div>
            <div class="picture" @click="detailsImage(userListObj.businessImg)">
              <img :src="userListObj.businessImg" alt />
            </div>
          </div>
        </div>
        <div class="name">刻章信息</div>
        <div class="box1">
          <div class="item">
            <div>公章：</div>
            <div class="picture" @click="detailsImage(userListObj.gongzhang)">
              <img :src="userListObj.gongzhang" alt />
            </div>
          </div>
          <div class="item">
            <div>发票章：</div>
            <div class="picture" @click="detailsImage(userListObj.fapiaozhang)">
              <img :src="userListObj.fapiaozhang" alt />
            </div>
          </div>
          <div class="item">
            <div>法人章：</div>
            <div class="picture" @click="detailsImage(userListObj.farenzhang)">
              <img :src="userListObj.farenzhang" alt />
            </div>
          </div>
          <div class="item">
            <div>财务章：</div>
            <div class="picture" @click="detailsImage(userListObj.caiwuzhang)">
              <img :src="userListObj.caiwuzhang" alt />
            </div>
          </div>
          <div class="item">
            <div>合同章：</div>
            <div class="picture" @click="detailsImage(userListObj.hetongzhang)">
              <img :src="userListObj.hetongzhang" alt />
            </div>
          </div>
        </div>
        <div class="name">开户信息</div>
        <div class="box1">
          <div class="list">
            <span>银行开户：{{userListObj.isBank}}</span>
            <span>账户名称：{{userListObj.bankName}}</span>
            <span>账号：{{userListObj.bankNo}}</span>
          </div>
          <div class="list">
            <span>开户行：{{userListObj.bank}}</span>
          </div>
          <div class="item">
            <div>账户：</div>
            <div class="picture" @click="detailsImage(userListObj.bankImg)">
              <img :src="userListObj.bankImg" alt />
            </div>
          </div>
        </div>
        <div class="name">税务报道</div>
        <div class="box1">
          <div class="item">
            <div>CA：</div>
            <div class="picture" @click="detailsImage(userListObj.caImg)">
              <img :src="userListObj.caImg" alt />
            </div>
          </div>
          <div class="item">
            <div>税务登记日：{{userListObj.taxRegDay || '暂无'}}</div>
          </div>
          <div class="item">
            <div>税务机构名称：{{userListObj.taxOrg || '暂无'}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 图片查看 -->
    <el-dialog title="图片查看" :visible.sync="dialogImg" width="50%" :before-close="handleClose">
      <div>
        <img :src="imageDetails" alt />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api/api.js";
import { get, post } from "@/api/index.js";
import pagination from "@/components/pagination";
export default {
  data() {
    return {
      imageDetails: "",
      dialogImg: false,
      dialogUser: false,
      auditOptions: [
        {
          value: "2",
          label: "审核失败"
        },
        {
          value: "1",
          label: "审核成功"
        }
      ],
      userListObj: {},
      userForm: {
        id: "",
        notes: "",
        status: ""
      },
      userOptions: [],
      userValue: "",
      orderCodeVal: "",
      statusVal: "",
      statusOptions: [
        {
          value: "2000",
          label: "办理中"
        },
        {
          value: "2010",
          label: "待签约"
        },
        {
          value: "2020",
          label: "已完成"
        }
      ],
      individualBusinessVal: "",
      signingType: true,
      detailsType: true,
      userTableData: [],
      total: null,
      pageSzie: 10,
      signingObj: {}
    };
  },
  mounted() {
    this.userOptions = JSON.parse(localStorage.getItem("nameList")) || [];
    this.deliverPagePost();
  },
  methods: {
    handleClose(done) {
      done();
    },
    detailsImage(src) {
      if (src) {
        this.imageDetails = src;
        this.dialogImg = true;
      }
    },
    // 查看详情
    userDetails(row) {
      console.log(row);
      this.detailsType = false;
      this.userListObj = row;
    },
    handleCurrentChange(size) {
      console.log(size);
      this.deliverPagePost(size);
    },
    handleSizeChange(val) {
      this.pageSzie = val;
      console.log(`每页 ${val} 条aaaaa`);
      this.deliverPagePost();
    },
    // 重置
    merchantsReset() {
      this.userValue = "";
      this.orderCodeVal = "";
      this.statusVal = "";
      this.individualBusinessVal = "";
      this.deliverPagePost();
    },
    // 搜索
    merchantsSearch() {
      this.deliverPagePost();
    },
    deliverPagePost(size) {
       const loading = this.$loading({
        lock: true,
        spinner: "loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      post(api.deliverPage, {
        currentPage: size || 1,
        pageSize: this.pageSzie,
        orderId: this.orderCodeVal,
        dstatus: this.statusVal
      }).then(
        d => {
          console.log(d.status);
           loading.close();
          if (d.status === 0) {
            console.log(d, "!!!!!!!!!!!!");
            this.total = d.data.count;
            this.userTableData = d.data.rows;
          } else {
            console.log(d.msg);
          }
        },
        err => {
          console.log(err.msg);
          //error callback
        }
      );
    }
  },
  components: {
    pagination: pagination
  }
};
</script>

<style lang="less" scoped>
.userInformation {
  width: 100%;
  padding: 22px 20px;
  box-sizing: border-box;
  overflow-y: auto;
  .main {
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    .top-search {
      width: 100%;
      overflow: hidden;
      .item {
        height: 46px;
        line-height: 46px;
        float: left;
        margin-bottom: 10px;
        margin-right: 20px;
        span {
          display: inline-block;
          width: 66px;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: right;
          margin-right: 10px;
        }
        div {
          display: inline-block;
          width: 233px;
          height: 46px;
        }
      }
    }
    .middle-button {
      width: 100%;
      text-align: left;
      padding-top: 10px;
    }
    .bottom-table {
      width: 100%;
      margin-top: 20px;
    }
    .bottom-pag {
      width: 100%;
      margin-top: 20px;
    }
  }
  .signing {
    min-width: 1300px;
    .title {
      width: 100%;
      height: 52px;
      line-height: 52px;
      .fanhui {
        float: left;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        position: relative;
        cursor: pointer;
      }
      .fanhui:after {
        content: "";
        position: absolute;
        top: 20px;
        right: -16px;
        width: 1px;
        height: 13px;
        background-color: #979797;
      }
      .qianyue {
        float: left;
        margin-left: 24px;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
      }
    }
    .header {
      width: 100%;
      // height:75px;
      // background:rgba(242,242,242,0.8);
      border-radius: 6px;
      padding: 28px 27px;
      box-sizing: border-box;
      text-align: left;
      margin-top: 10px;
      .item {
        min-width: 33%;
        display: inline-block;
        line-height: 40px;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        // margin-right: 55px;
        margin-bottom: 15px;
        div {
          display: inline-block;
        }
        span {
          float: left;
        }
      }
      // span {
      //   display: inline-block;
      //   font-size:14px;
      //   font-family:PingFangSC;
      //   font-weight:400;
      //   color:rgba(51,51,51,1);
      //   margin-right: 55px;
      // }
    }
    .subtitle {
      width: 100%;
      height: 53px;
      background: rgba(180, 220, 255, 0.3);
      border-radius: 4px;
      line-height: 53px;
      text-align: left;
      font-size: 14px;
      font-family: PingFangSC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      margin-top: 20px;
      padding-left: 27px;
      box-sizing: border-box;
    }
    .box {
      margin-top: 20px;
      width: 100%;
      // min-height:361px;
      padding-bottom: 20px;
      border-radius: 6px;
      border: 1px solid rgba(195, 195, 195, 0.8);
      .title {
        width: 100%;
        height: 51px;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        padding-left: 27px;
        box-sizing: border-box;
        line-height: 51px;
        text-align: left;
      }
      .content {
        width: 1200px;
        height: auto;
        margin: 0 auto;
        margin-top: 20px;
        div {
          width: 100%;
          padding-right: 10px;
          box-sizing: border-box;
          overflow: hidden;
          position: relative;
          .middle {
            width: 40%;
            height: 100%;
            float: left;
            span {
              display: inline-block;
              width: 210px;
              height: 100%;
              margin-right: 20px;
            }
          }
          .left {
            width: 20%;
            height: 100%;
            float: left;
          }
          .right {
            width: 20%;
            height: 100%;
            float: right;
            span {
              display: inline-block;
              // width:84px;
              height: 100%;
            }
            i:hover {
              color: #409eff;
            }
          }
          i {
            position: absolute;
            right: 10px;
            top: 18px;
            color: #c3c3c3;
            font-size: 18px;
            cursor: pointer;
          }
        }
        .ladder {
          width: 100%;
          height: 56px;
          line-height: 56px;
        }
        .top {
          width: 100%;
          height: 46px;
          line-height: 46px;
          background: rgba(240, 240, 240, 1);
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(70, 92, 109, 1);
        }
        .bottom {
          width: 100%;
          height: 46px;
          line-height: 46px;
          text-align: center;
          background: rgba(232, 244, 255, 1);
          border: 1px solid rgba(193, 225, 255, 1);
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(40, 152, 255, 1);
          cursor: pointer;
        }
      }
    }
  }
  .details {
    .title {
      width: 100%;
      height: 52px;
      line-height: 52px;
      .fanhui {
        float: left;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        position: relative;
        cursor: pointer;
      }
      .fanhui:after {
        content: "";
        position: absolute;
        top: 20px;
        right: -16px;
        width: 1px;
        height: 13px;
        background-color: #979797;
      }
      .qianyue {
        float: left;
        margin-left: 24px;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }
    }
    .content {
      width: 100%;
      .name {
        width: 100%;
        font-size: 14px;
        font-family: PingFangSC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        text-align: left;
        padding-left: 10px;
        box-sizing: border-box;
      }
      .box {
        margin-top: 10px;
        width: 100%;
        padding: 30px 10px;
        box-sizing: border-box;
        background: rgba(250, 250, 250, 1);
        border-radius: 6px;
        text-align: left;
        span {
          display: inline-block;
          font-size: 14px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin: 0px 55px;
          line-height: 36px;
        }
      }
      .box1 {
        margin-top: 10px;
        width: 100%;
        padding: 30px 10px;
        box-sizing: border-box;
        border-radius: 6px;
        text-align: left;
        overflow: hidden;
        color: rgba(16, 16, 16, 1);
        font-size: 14px;
        text-align: left;
        font-family: SourceHanSansSC-regular;
        .list {
          width: 100%;
          margin-bottom: 20px;
          span {
            display: inline-block;
            width: 33.33%;
            height: 100%;
          }
        }
        .item {
          float: left;
          height: 93px;
          margin-right: 100px;
          margin-bottom: 20px;
          div {
            float: left;
            min-width: 55px;
            height: 93px;
          }
          .picture {
            width: 167px;
            height: 93px;
            background: rgba(246, 246, 246, 1);
            border-radius: 8px;
            border: 1px solid rgba(198, 198, 198, 1);
            img {
              cursor: pointer;
              display: block;
              height: 100%;
              margin: 0 auto;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/trading/soho/userInformation.vue